module.exports = __webpack_public_path__ + "img/351.e354a194.jpg";